var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWireless(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 8.75C50.9946 8.75 51.9484 9.14509 52.6516 9.84835C53.3549 10.5516 53.75 11.5054 53.75 12.5V47.5C53.75 48.4946 53.3549 49.4484 52.6516 50.1516C51.9484 50.8549 50.9946 51.25 50 51.25C49.0054 51.25 48.0516 50.8549 47.3484 50.1516C46.6451 49.4484 46.25 48.4946 46.25 47.5V12.5C46.25 11.5054 46.6451 10.5516 47.3484 9.84835C48.0516 9.14509 49.0054 8.75 50 8.75ZM40 16.25C40.9946 16.25 41.9484 16.6451 42.6516 17.3483C43.3549 18.0516 43.75 19.0054 43.75 20V47.5C43.75 48.4946 43.3549 49.4484 42.6516 50.1516C41.9484 50.8549 40.9946 51.25 40 51.25C39.0054 51.25 38.0516 50.8549 37.3483 50.1516C36.6451 49.4484 36.25 48.4946 36.25 47.5V20C36.25 19.0054 36.6451 18.0516 37.3483 17.3483C38.0516 16.6451 39.0054 16.25 40 16.25ZM30 23.75C30.9946 23.75 31.9484 24.1451 32.6517 24.8483C33.3549 25.5516 33.75 26.5054 33.75 27.5V47.5C33.75 48.4946 33.3549 49.4484 32.6517 50.1516C31.9484 50.8549 30.9946 51.25 30 51.25C29.0054 51.25 28.0516 50.8549 27.3483 50.1516C26.6451 49.4484 26.25 48.4946 26.25 47.5V27.5C26.25 26.5054 26.6451 25.5516 27.3483 24.8483C28.0516 24.1451 29.0054 23.75 30 23.75ZM20 31.25C20.9946 31.25 21.9484 31.6451 22.6517 32.3483C23.3549 33.0516 23.75 34.0054 23.75 35V47.5C23.75 48.4946 23.3549 49.4484 22.6517 50.1516C21.9484 50.8549 20.9946 51.25 20 51.25C19.0054 51.25 18.0516 50.8549 17.3483 50.1516C16.6451 49.4484 16.25 48.4946 16.25 47.5V35C16.25 34.0054 16.6451 33.0516 17.3483 32.3483C18.0516 31.6451 19.0054 31.25 20 31.25ZM10 38.75C10.9946 38.75 11.9484 39.1451 12.6517 39.8483C13.3549 40.5516 13.75 41.5054 13.75 42.5V47.5C13.75 48.4946 13.3549 49.4484 12.6517 50.1516C11.9484 50.8549 10.9946 51.25 10 51.25C9.00544 51.25 8.05161 50.8549 7.34835 50.1516C6.64509 49.4484 6.25 48.4946 6.25 47.5V42.5C6.25 41.5054 6.64509 40.5516 7.34835 39.8483C8.05161 39.1451 9.00544 38.75 10 38.75Z",
    fill: "url(#paint0_linear_2375_418)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2375_418",
    x1: 30,
    y1: 8.75,
    x2: 30,
    y2: 51.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWireless);
export default __webpack_public_path__ + "static/media/Wireless.ea5138b12d2c212b5d6d8105da634f1f.svg";
export { ForwardRef as ReactComponent };